
import router from 'frontend/router';

import ProductCustomizer from './comp/ProductCustomizer.vue';

router.addRoutes([
	{
		name: 'product-customizer',
		path: '/customize/:productSlug',
		props: true,
		component: ProductCustomizer,
	}
]);